<label>{{ 'Register.Label.Language' | translate }}<span *ngIf="showAsterisk" class="required-field">*</span></label>
<ng-select [(ngModel)]="value" [items]="languages" bindLabel="name" name="language-select"
    [searchFn]="startsWithSearchFn" [ngClass]="{'ng-field-selected': isFilled}" [keyDownFn]="selectOnTab">
</ng-select>
